// CDN経由でgsapを読み込むため、インポートを削除
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { mediaQuerySm,mediaQueryMd,mediaQueryLg } from './media-query';

// 必要なプラグインのみを登録
gsap.registerPlugin(ScrollTrigger);


/**
 * topからのスクロールでクラス追加。リサイズ対応で関数化
 * @param {*} elemTarget
 * @param {*} classNameAdd
 */
export function fixedButton(elemTarget){

  const eventList = {
    'enter' : function () {
      // console.log('enter');
      gsap.to(elemTarget, {
        autoAlpha: 1,
        duration: .2,
      });
    },
    'leave' : function () {
      // console.log('leave');
      gsap.to(elemTarget, {
        autoAlpha: 0,
        duration: .2,
      });
    }
  };

  const gsapButton = (mediaQuery) => {
    if (mediaQuery.matches) {
      ScrollTrigger.create({
        trigger: document.body,
        start: '300px top',
        end: document.body.innerHeight,
        onEnter: function () { eventList.enter(); },
        onLeaveBack: function () { eventList.leave(); },
        onLeave: function () { eventList.leave(); },
        onEnterBack: function () { eventList.enter(); }
      });
    }
  };

  if (document.querySelector(elemTarget)) {
    //リサイズ対応
    mediaQueryMd.addEventListener('change', gsapButton);
    // 初期化
    gsapButton(mediaQueryMd);
  }

}


/**
 * コンテンツフェードイン
 * ロード時の誤動作対策のため.js-fadeup, .js-fadeup__once にはcssで opacity: 0;
 */
export function fadeUpContent(){
  document.querySelectorAll('.js-fadeup').forEach((elem) => {
    gsap.fromTo(elem,
      {
        autoAlpha: 0,
        y:30,
      },
      {
        autoAlpha: 1,
        y:0,
        duration: .4,
        ease: 'power1.out',
        scrollTrigger: {
          trigger: elem,
          start: 'top bottom-=20%' ,
          toggleActions: 'restart none none reverse',
        }
      }
    );
  });
  document.querySelectorAll('.js-fadeup__once').forEach((elem) => {
    gsap.fromTo(elem,
      {
        autoAlpha: 0,
        y:30,
      },
      {
        autoAlpha: 1,
        y:0,
        duration: .4,
        ease: 'power1.out',
        scrollTrigger: {
          trigger: elem,
          start: 'top bottom-=20%' ,
        }
      }
    );
  });
}


/**
 * 時間差 フェードイン for ulタグ
 * ロード時の誤動作対策のため..js-fadeup__stagger--list を追加して liに opacity: 0; セット
 */
export function staggerFadeupForList(elemUlClass){
  document.querySelectorAll(elemUlClass).forEach((elemUl) => {
    const target = elemUl.querySelectorAll('li');
    const itemCount = target.length; // liアイテムの数をカウント
    gsap.fromTo(target,
      {
        autoAlpha: 0,
        y: 30,
      },
      {
        autoAlpha: 1,
        y: 0,
        duration: .4,
        ease: 'power1.out',
        scrollTrigger: {
          trigger: elemUl,
          start: 'top bottom-=20%',
          // toggleActions: 'restart none none reverse',
        },
        stagger: {
          from: 'start',
          amount: itemCount * 0.1,
        },
      }
    );
  });
}
